import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'sanitizeSrc'
})
export class SanitizeSrcService implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(v: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustResourceUrl(v);
    }
}